export default __webpack_public_path__ + "static/media/spec-qc-1.b91c6005.jpg";